import { InjectionToken, Provider } from '@angular/core';
import { RecordManagerService } from './record-manager.service';

export const RECORD_MANAGER = new InjectionToken<RecordManagerService>('RECORD_MANAGER');

export function provideRecordManager(): Provider[] {
	return [
		{
			provide: RECORD_MANAGER,
			useClass: RecordManagerService,
		},
	];
}
